'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { AsyncStaticPriceText } from '@udemy-v2/react-course-pricing';
import { useMatchMedia } from '@udemy-v2/design-system-utils';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { ClpCartSuccessModal } from '@/features/course-landing-page/components/clp-cart-success-modal';
import { AddToCartButton } from '@udemy-v2/react-shopping-buttons';
import styles from './transactional-sticky-footer-content.module.scss';

/**
 * TransactionalStickyFooterContent component displays price and CTA button for transactional purchases.
 * Renders for paid courses that are not included in a subscription and when the user is not already enrolled.
 */
export const TransactionalStickyFooterContent: React.FC = () => {
  const $ = _c(16);
  const course = useClpCourse();
  const isMobile = useMatchMedia("sm-max");
  const t0 = Number(course.id);
  let t1;
  if ($[0] !== t0) {
    t1 = <AsyncStaticPriceText listPriceClassName="ud-heading-lg" courseId={t0} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = Number(course.id);
  let t3;
  if ($[2] !== course.frontendTrackingId || $[3] !== t2) {
    t3 = [{
      id: t2,
      buyableObjectType: "course",
      frontendTrackingId: course.frontendTrackingId
    }];
    $[2] = course.frontendTrackingId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      size: "large",
      typography: "ud-heading-md",
      udStyle: "primary"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== course || $[7] !== isMobile) {
    t5 = !isMobile ? <ClpCartSuccessModal course={course} /> : undefined;
    $[6] = course;
    $[7] = isMobile;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !!isMobile;
  let t7;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <AddToCartButton buyables={t3} buttonStyleProps={t4} className={styles["transactional-cta-button"]} addToCartSuccessModal={t5} forceRedirectToCart={t6} />;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t7) {
    t8 = <div className={styles.container}>{t1}{t7}</div>;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};